import { useQuery } from '@tanstack/react-query';

import { createEntityMutations } from '../../../shared/api/createEntityMutations.js';
import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';

import {
  createNote,
  deleteNote,
  getNotesQueryKey,
  listNotes,
  updateNote,
  type CreateNoteInput,
  type ListNotesFilters,
  type NoteItem,
  type UpdateNoteInput,
} from '../api/notes.client.js';

export function useNotes(filters: ListNotesFilters = {}, options: { enabled?: boolean } = {}) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';

  return useQuery({
    queryKey: getNotesQueryKey(workspaceId, filters),
    queryFn: () => listNotes(filters),
    // `enabled` нужен выбору «прикрепить существующую»: без него список всех
    // заметок пространства грузился бы на каждой карточке, а к моменту открытия
    // выбора успевал устареть.
    enabled: scope !== null && (options.enabled ?? true),
  });
}

// Панели сделки, контакта и компании читают заметки тем же корнем `notes`,
// поэтому инвалидации префикса достаточно — дополнительные корни не нужны.
const noteMutations = createEntityMutations<NoteItem, CreateNoteInput, UpdateNoteInput>({
  key: 'notes',
  create: createNote,
  update: updateNote,
  remove: deleteNote,
});

export const useCreateNoteMutation = noteMutations.useCreate;
export const useUpdateNoteMutation = noteMutations.useUpdate;
export const useDeleteNoteMutation = noteMutations.useDelete;
